const DotsIcon = (props) => {
  return (
    <svg
      width="16"
      height="5"
      {...props}
      viewBox="0 0 16 5"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 0.5C0.9 0.5 0 1.4 0 2.5C0 3.6 0.9 4.5 2 4.5C3.1 4.5 4 3.6 4 2.5C4 1.4 3.1 0.5 2 0.5ZM14 0.5C12.9 0.5 12 1.4 12 2.5C12 3.6 12.9 4.5 14 4.5C15.1 4.5 16 3.6 16 2.5C16 1.4 15.1 0.5 14 0.5ZM8 0.5C6.9 0.5 6 1.4 6 2.5C6 3.6 6.9 4.5 8 4.5C9.1 4.5 10 3.6 10 2.5C10 1.4 9.1 0.5 8 0.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DotsIcon;
